import Swal from "sweetalert2";
import request from "request";
import axios from "axios";
import { API, Auth } from "aws-amplify";

/**
 *
 * @param {("SUCCESS" | "ERROR" | "WARNING")} status
 * @param {object = { text: "", logMessage: "" }} options
 * @returns
 */
export const EmitterStatus = async (
  status,
  options = { text: "", logMessage: "" }
) => {
  const default_text = {
    SUCCESS: "อัพเดตข้อมูลสำเร็จ",
    ERROR: "อัพเดตข้อมูลไม่สำเร็จ",
    WARNING: "โปรดกรอกข้อมูลให้ครบ",
  };

  const text = options.text ? options.text : default_text[status];
  console.log("options.text", options.text)

  switch (status) {
    case "SUCCESS":
      return await Swal.fire({
        title: status,
        text,
        icon: "success",
        confirmButtonText: "ยืนยัน",
      });
    case "WARNING":
      return await Swal.fire({
        title: "WARNING",
        text,
        icon: "warning",
        confirmButtonText: "ยืนยัน",
      });
    case "ERROR":
      //   await lineNotify(options.logMessage);
      await Swal.fire({
        title: "ERROR",
        text,
        icon: "error",
        confirmButtonText: "ยืนยัน",
      });
      return;
    default:
      break;
  }
};

const lineNotify = async (logMessage) => {
  await API.post("MoneyHubAdmin", `/lineNotify`, {
    body: {
      message: "HELLO NOTI",
    },
    headers: {
      Authorization: `Bearer ${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`,
    },
  });
  //   const tokenCelestial = "LC8AA9jWf3CzBHXlF07ei3zyCpsJZLEL9EQxowJM1bR";
  //   const tokenList = ["zkYNbf7EwYPQ3k122OsGMrA4XTENHNAS0u06cwW2cUV"];

  //   console.log("LOG MESSAGE", logMessage);

  //   await Promise.all(
  //     tokenList.map(async (token) => {
  //       if (!token) return;

  //   j3blnyHelb70iDaSzLDp0Df9AU9JDeb4BIuxfk9M1Kp

  //   await fetch({
  //     method: "POST",
  //     // mode: "no-cors",
  //     url: "https://notify-api.line.me/api/notify",
  //     headers: {
  //       "Content-Type": "application/x-www-form-urlencoded",
  //     },
  //     auth: {
  //       bearer: "j3blnyHelb70iDaSzLDp0Df9AU9JDeb4BIuxfk9M1Kp",
  //     },
  //     formData: {
  //       message: "TEST ERROR",
  //     },
  //   });
  //   await axios({
  //     method: "post",
  //     url: "https://notify-api.line.me/api/notify",
  //     headers: {
  //       "Content-Type": "application/x-www-form-urlencoded",
  //       Authorization: "Bearer " + tokenCelestial,
  //     },
  //     data: "message=TESTERROR",
  //   })
  //     .then((response) => {
  //       console.log(response);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  //   await request(
  //     {
  //       method: "POST",
  //       uri: "https://notify-api.line.me/api/notify",
  //       headers: {
  //         "Content-Type": "application/x-www-form-urlencoded",
  //         Authorization: `Bearer ${token}`,
  //         "Access-Control-Allow-Origin": "*",
  //       },
  //       //   auth: {
  //       //     bearer: token,
  //       //   },
  //       data: {
  //         message: "TEST ERROR",
  //       },
  //     },
  //     (err, httpResponse, body) => {
  //       if (err) {
  //         console.log(err);
  //         return err;
  //       } else {
  //         return body;
  //       }
  //     }
  //   );
  //     })
  //   );
};
